export default "__VITE_ASSET__20bd8521__"